export const CustomLesson = [{
    'ktpId': 'class_hour',
    'nameShort': '**Классный час',
    'name': 'Классный час',
    'stayHours': 100,
}];